module.exports = __webpack_public_path__ + "img/pc_p3_z3.9935b6f7.png";